<template>
  <div class="text">
    <span class="text__fake">{{ text }}</span>

    <transition
      enter-active-class="animate__animated animate__flipInX"
      leave-active-class="animate__animated animate__flipOutX"
    >
    <span v-if="isEntering" class="text__real">{{ text }}</span>
  </transition>
  </div>
</template>

<script>
  export default {
    props: {
      texts: { type: Array, required: true }
    },
    
    data: () => ({
      index: 0,
      isEntering: true
    }),

    mounted () {
      setInterval(() => {
        this.isEntering = false

        this.index = (this.index == this.texts.length - 1) ? 0 : ++this.index

        setTimeout(() => {
          this.isEntering = true
        }, 550)
      }, 5000);
    },

    computed: {
      text () {
        return this.texts[this.index]
      }
    }
  }
</script>

<style scoped lang="scss">
  .text {
    display: inline-block;
    position: relative;

    &__fake {
      visibility: hidden;
    }

    &__real {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
</style>
